import { ApolloClient } from '@apollo/client';
import { EmailAvailabilityQuery } from './queries';
import { MakeEmailAvailabilityQueryData } from './types';

export const validatePassword = (value: string) => {
  if (!/\d/.test(value)) {
    return 'Password must have at least one number';
  }
  if (!/[A-z]/.test(value)) {
    return 'Password must have at least one letter';
  }
  return undefined;
};

export const makeEmailAvailability = (
  apolloClient: ApolloClient<any>,
  inviteToken?: string
) => {
  return async (email: string) => {
    if (!email || email.length === 0) {
      return undefined;
    }

    const availabilityResponse =
      await apolloClient.query<MakeEmailAvailabilityQueryData>({
        query: EmailAvailabilityQuery,
        variables: {
          input: {
            email,
            inviteToken,
          },
        },
      });

    return availabilityResponse.data.emailAvailable.available
      ? undefined
      : 'This email is unavailable';
  };
};
